// extracted by mini-css-extract-plugin
export default {"labelTd":"ThongTinDonvi_labelTd__3c7ln","tr":"ThongTinDonvi_tr__GVLdF"};